/**
 * Labels on the terms and privacy pages. The documents themselves are in
 * src/legal/ (paragraphs and lists do not fit t()).
 */
const legal = {
  en: {
    operator: { name: "Operator", address: "Address", taxId: "Tax ID", phone: "Phone", whatsapp: "WhatsApp" },
  },
  fr: {
    operator: { name: "Opérateur", address: "Adresse", taxId: "Identifiant fiscal", phone: "Téléphone", whatsapp: "WhatsApp" },
  },
  ar: {
    operator: { name: "المشغّل", address: "العنوان", taxId: "المعرّف الجبائي", phone: "الهاتف", whatsapp: "واتساب" },
  },
};

export default legal;
